module.exports = __webpack_public_path__ + "img/black-logo.342e4bc2.png";